import { Record, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export const ALERTS_REDUCER_KEY = 'alertsStore';
export type ALERTS_REDUCER_KEY = typeof ALERTS_REDUCER_KEY;

export const IconBgColors = Object.freeze({
  COLOR1: 'color1',
  COLOR2: 'color2',
  COLOR3: 'color3',
  COLOR4: 'color4',
  COLOR5: 'color5',
  COLOR6: 'color6',
  COLOR7: 'color7',
  COLOR8: 'color8',
  COLOR9: 'color9',
});
export type IconBgColorsType = (typeof IconBgColors)[keyof typeof IconBgColors];

export type AlertProps = {
  id?: string;
  isDeleted?: boolean;
  createdAt?: string;
  modifiedAt?: string;
  group?: string;
  type?: string;
  title?: string;
  icon?: string;
  iconBgColor?: IconBgColorsType;
  message?: string;
  isRead?: boolean;
  isDismissed?: boolean;
  deepLinkUri?: string;
  deepLinkComponent?: string;
  deepLinkEntityId?: string;
};

export type Alert = RecordOf<AlertProps>;

export const mkAlert = Record<AlertProps>({
  id: undefined,
  isDeleted: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  group: undefined,
  type: undefined,
  title: undefined,
  icon: undefined,
  iconBgColor: undefined,
  message: undefined,
  isRead: false,
  isDismissed: false,
  deepLinkUri: undefined,
  deepLinkComponent: undefined,
  deepLinkEntityId: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [ALERTS_REDUCER_KEY]: QcsSyncResourceStore<AlertProps>;
  }
}
